import React, { useState } from 'react';
import { Logo } from './Logo';
import { colors, spacing, typography } from '../theme';
import { useIsMobile } from '../hooks/useIsMobile';
export const NavBar = ({ links = [], rightSlot }) => {
    const isMobile = useIsMobile();
    const [menuOpen, setMenuOpen] = useState(false);
    const linkStyle = {
        color: colors.textMuted,
        textDecoration: 'none',
        fontSize: typography.fontSizeSm,
        fontFamily: typography.fontFamily,
        transition: 'color 0.15s',
    };
    return (React.createElement("nav", { style: {
            backgroundColor: colors.dark,
            padding: `${spacing.sm}px ${isMobile ? spacing.md : spacing.xl}px`,
            position: 'sticky',
            top: 0,
            zIndex: 100,
            boxShadow: '0 1px 4px rgba(0,0,0,0.3)',
        } },
        React.createElement("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' } },
            React.createElement("a", { href: "/", style: { textDecoration: 'none', display: 'flex', alignItems: 'center' } },
                React.createElement(Logo, { size: typography.fontSizeMd })),
            isMobile ? (React.createElement("button", { "aria-label": menuOpen ? 'Close menu' : 'Open menu', "aria-expanded": menuOpen, onClick: () => setMenuOpen((o) => !o), style: {
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    color: colors.white,
                    fontSize: 22,
                    lineHeight: 1,
                    padding: `${spacing.xs}px`,
                } }, menuOpen ? '✕' : '☰')) : (React.createElement("div", { style: { display: 'flex', gap: spacing.lg, alignItems: 'center' } },
                links.map((link) => (React.createElement("a", { key: link.href, href: link.href, onClick: link.onClick, style: linkStyle, onMouseEnter: (e) => (e.currentTarget.style.color = colors.white), onMouseLeave: (e) => (e.currentTarget.style.color = colors.textMuted) }, link.label))),
                rightSlot))),
        isMobile && menuOpen && (React.createElement("div", { style: {
                display: 'flex',
                flexDirection: 'column',
                gap: spacing.sm,
                paddingTop: spacing.sm,
                borderTop: '1px solid rgba(255,255,255,0.1)',
                marginTop: spacing.sm,
            } },
            links.map((link) => (React.createElement("a", { key: link.href, href: link.href, onClick: () => { link.onClick?.(); setMenuOpen(false); }, style: {
                    ...linkStyle,
                    padding: `${spacing.sm}px 0`,
                    fontSize: typography.fontSizeBase,
                } }, link.label))),
            rightSlot && React.createElement("div", { style: { paddingTop: spacing.xs } }, rightSlot)))));
};
